export default __webpack_public_path__ + "static/media/game_icon4.4df80f76.png";